/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/creditcard/CreditCardScannerScreenConfiguration.yaml
import { CreditCardScannerConfiguration } from '../../credit_card/CreditCardTypes';
import { AspectRatio } from '../../geometry/Geometry';
import { ActionBarConfiguration } from '../common/ActionBarConfiguration';
import { CameraConfiguration } from '../common/CameraConfiguration';
import { CameraPermissionScreen } from '../common/CameraPermission';
import { BackgroundStyle, ButtonConfiguration, EdgeInsets, ForegroundStyle, IconButton, IconStyle, Palette, RoundButton, Sound, StyledText, Vibration, } from '../common/Common';
import { ScanCompletionOverlay } from '../common/ScanCompletionOverlay';
import { TopBarConfiguration } from '../common/TopBarConfiguration';
import { UserGuidanceConfiguration } from '../common/UserGuidanceConfiguration';
import { FinderCorneredStyle, PermanentViewFinderConfiguration } from '../common/ViewFinderConfiguration';
import { CreditCardScannerIntroScreenConfiguration } from './CreditCardScannerIntroScreenConfiguration';
import { CreditCardScannerScreenTextLocalization } from './CreditCardScannerScreenTextLocalization';
import { CreditCardScanGuidanceConfiguration } from './CreditCardScannerUserGuidance';
import { CreditCardScanningProgressConfiguration } from './CreditCardScanningProgressConfiguration';
/**
Configuration of the screen for detecting credit card data.
*/
export class CreditCardScannerScreenConfiguration {
    /** @param source {@displayType `DeepPartial<CreditCardScannerScreenConfiguration>`} */
    constructor(source = {}) {
        /**
          Version number of the configuration object.
          
          Default is "1.0"
          */
        this.version = '1.0';
        /**
          The configuration object should be applied for this screen.
          
          Default is "CreditCardScanner"
          */
        this.screen = 'CreditCardScanner';
        /**
          Configuration of the all strings for credit card scanner screen.
          */
        this.localization = new CreditCardScannerScreenTextLocalization({});
        /**
          Define the screen's base color values from which other colors are derived.
          */
        this.palette = new Palette({});
        /**
          The background color of the credit card scanner screen.
          
          Default is "?sbColorSurfaceLow"
          */
        this.backgroundColor = '?sbColorSurfaceLow';
        /**
          Configuration of the camera behavior.
          */
        this.cameraConfiguration = new CameraConfiguration({ orientationLockMode: 'PORTRAIT' });
        /**
          Configuration of the dialog for requesting camera permissions.
          */
        this.cameraPermission = new CameraPermissionScreen({
            statusBarMode: 'DARK',
            background: '?sbColorSurface',
            iconBackground: '?sbColorOutline',
            icon: new IconStyle({ visible: true, color: '?sbColorOnSurface' }),
            enableCameraButton: new ButtonConfiguration({
                visible: true,
                text: '?cameraPermissionEnableCameraButton',
                accessibilityDescription: '?accessibilityDescriptionCameraPermissionEnableCameraButton',
                background: new BackgroundStyle({
                    strokeColor: '?sbColorPrimary',
                    fillColor: '?sbColorPrimary',
                    strokeWidth: 0.0,
                }),
                foreground: new ForegroundStyle({ iconVisible: false, color: '?sbColorOnPrimary', useShadow: false }),
            }),
            closeButton: new ButtonConfiguration({
                visible: true,
                text: '?cameraPermissionCloseButton',
                accessibilityDescription: '?accessibilityDescriptionCameraPermissionCloseButton',
                background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
                foreground: new ForegroundStyle({ iconVisible: false, color: '?sbColorPrimary', useShadow: false }),
            }),
            enableCameraTitle: new StyledText({ text: '?cameraPermissionEnableCameraTitle', color: '?sbColorOnSurface' }),
            enableCameraExplanation: new StyledText({
                text: '?cameraPermissionEnableCameraExplanation',
                color: '?sbColorOnSurfaceVariant',
            }),
        });
        /**
          Configuration of the top user guidance.
          */
        this.topUserGuidance = new UserGuidanceConfiguration({
            title: new StyledText({ text: '?topUserGuidance' }),
        });
        /**
          Configuration of the user guidance for the scanning status.
          */
        this.scanStatusUserGuidance = new CreditCardScanGuidanceConfiguration({});
        /**
          Configuration of the top bar on the credit card scanner screen.
          */
        this.topBar = new TopBarConfiguration({
            title: new StyledText({ visible: true, text: '?topBarTitle' }),
            cancelButton: new ButtonConfiguration({
                text: '?topBarCancelButton',
                accessibilityDescription: '?accessibilityDescriptionCancelButton',
                background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
                foreground: new ForegroundStyle({ color: '?sbColorOnPrimary' }),
            }),
        });
        /**
          Configuration of the button in the top bar that opens the introduction screen.
          */
        this.topBarOpenIntroScreenButton = new IconButton({
            color: '?sbColorOnPrimary',
            accessibilityDescription: '?accessibilityDescriptionOpenIntroScreenButton',
        });
        /**
          Configuration of the introduction screen for the credit card scanner.
          */
        this.introScreen = new CreditCardScannerIntroScreenConfiguration({});
        /**
          Configuration of the action bar.
          */
        this.actionBar = new ActionBarConfiguration({
            flipCameraButton: new RoundButton({
                visible: false,
                accessibilityDescription: '?accessibilityDescriptionFlipCameraButton',
                accessibilityState: '?accessibilityStateFlipCameraBackButton',
                activeAccessibilityState: '?accessibilityStateFlipCameraFrontButton',
                backgroundColor: '?sbColorSurfaceHigh',
                foregroundColor: '?sbColorOnPrimary',
                activeBackgroundColor: '?sbColorWarning',
                activeForegroundColor: '#1C1B1F',
            }),
        });
        /**
          Configuration of the view finder.
          */
        this.viewFinder = new PermanentViewFinderConfiguration({
            style: new FinderCorneredStyle({ strokeColor: '?sbColorSurface', strokeWidth: 2.0 }),
            aspectRatio: new AspectRatio({ width: 1.586, height: 1.0 }),
            minimumInsets: new EdgeInsets({ top: 24.0, left: 24.0, bottom: 24.0, right: 24.0 }),
        });
        /**
          Configuration for the credit card recognizer.
          */
        this.scannerConfiguration = new CreditCardScannerConfiguration({});
        /**
          Flag to show or hide the preset button.
          
          Default is true
          */
        this.exampleOverlayVisible = true;
        /**
          Configuration of visualization of the scanning progress.
          */
        this.scanningProgress = new CreditCardScanningProgressConfiguration({});
        /**
          Timeout for the scan process. If the scan process takes longer than this value, the incomplete result will be returned.
          
          Default is 3000
          */
        this.scanIncompleteDataTimeout = 3000;
        /**
          Configuration of the success overlay.
          */
        this.successOverlay = new ScanCompletionOverlay({});
        /**
          Configuration of the success overlay.
          */
        this.incompleteDataOverlay = new ScanCompletionOverlay({
            message: new StyledText({ text: '?completionOverlayIncompleteDataMessage' }),
        });
        /**
          Configuration of the scan confirmation sound.
          */
        this.sound = new Sound({});
        /**
          Configuration of the vibration feedback.
          */
        this.vibration = new Vibration({});
        /**
          If enabled, the screen will not turn off while the credit card scanner is active.
          
          Default is true
          */
        this.keepScreenOn = true;
        if (source.version !== undefined) {
            this.version = source.version;
        }
        if (source.screen !== undefined) {
            this.screen = source.screen;
        }
        if (source.localization !== undefined) {
            this.localization = new CreditCardScannerScreenTextLocalization(source.localization);
        }
        if (source.palette !== undefined) {
            this.palette = new Palette(source.palette);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.cameraConfiguration !== undefined) {
            this.cameraConfiguration = new CameraConfiguration(source.cameraConfiguration);
        }
        if (source.cameraPermission !== undefined) {
            this.cameraPermission = new CameraPermissionScreen(source.cameraPermission);
        }
        if (source.topUserGuidance !== undefined) {
            this.topUserGuidance = new UserGuidanceConfiguration(source.topUserGuidance);
        }
        if (source.scanStatusUserGuidance !== undefined) {
            this.scanStatusUserGuidance = new CreditCardScanGuidanceConfiguration(source.scanStatusUserGuidance);
        }
        if (source.topBar !== undefined) {
            this.topBar = new TopBarConfiguration(source.topBar);
        }
        if (source.topBarOpenIntroScreenButton !== undefined) {
            this.topBarOpenIntroScreenButton = new IconButton(source.topBarOpenIntroScreenButton);
        }
        if (source.introScreen !== undefined) {
            this.introScreen = new CreditCardScannerIntroScreenConfiguration(source.introScreen);
        }
        if (source.actionBar !== undefined) {
            this.actionBar = new ActionBarConfiguration(source.actionBar);
        }
        if (source.viewFinder !== undefined) {
            this.viewFinder = new PermanentViewFinderConfiguration(source.viewFinder);
        }
        if (source.scannerConfiguration !== undefined) {
            this.scannerConfiguration = new CreditCardScannerConfiguration(source.scannerConfiguration);
        }
        if (source.exampleOverlayVisible !== undefined) {
            this.exampleOverlayVisible = source.exampleOverlayVisible;
        }
        if (source.scanningProgress !== undefined) {
            this.scanningProgress = new CreditCardScanningProgressConfiguration(source.scanningProgress);
        }
        if (source.scanIncompleteDataTimeout !== undefined) {
            this.scanIncompleteDataTimeout = source.scanIncompleteDataTimeout;
        }
        if (source.successOverlay !== undefined) {
            this.successOverlay = new ScanCompletionOverlay(source.successOverlay);
        }
        if (source.incompleteDataOverlay !== undefined) {
            this.incompleteDataOverlay = new ScanCompletionOverlay(source.incompleteDataOverlay);
        }
        if (source.sound !== undefined) {
            this.sound = new Sound(source.sound);
        }
        if (source.vibration !== undefined) {
            this.vibration = new Vibration(source.vibration);
        }
        if (source.keepScreenOn !== undefined) {
            this.keepScreenOn = source.keepScreenOn;
        }
    }
}
//# sourceMappingURL=CreditCardScannerScreenConfiguration.js.map